const axios = require("axios").default;

const URL = `${process.env.REACT_APP_API_URL}/role`;
const URL_ID = `${process.env.REACT_APP_API_URL}/permission/tree`;

export const getAll = (payload) => {
  return axios.get(URL, {
    params: payload,
  });
};

export const getPermissionId = (id) => {
  return axios.get(`${URL_ID}/${id}`, {
    params: id,
  });
};

export const createItem = (payload) => {
  return axios.post(URL, payload).catch((error) => {
    if (error.response) {
      return error.response.data;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const updateItem = (payload, id) => {
  return axios.post(`${URL_ID}/${id}`, payload).catch((error) => {
    if (error.response) {
      return error.response.data;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

// export const updateItem = (payload, id) => {
//   return axios.put(`${URL}/${id}`, payload);
// };

export const deleteById = (payload) => {
  return axios.delete(URL, payload).catch((error) => {
    if (error.response) {
      return error.response.data;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

// export const deleteById = (id) => {
//   return axios.delete(`${URL}/${id}`);
// };
